export const TENANT_ROLES = ['tenant_admin', 'tenant_member'] as const;
export type TenantRole = (typeof TENANT_ROLES)[number];

export const PERMISSIONS = [
  'tenant.manage',
  'member.read',
  'member.manage',
  'agent.read',
  'agent.create',
  'agent.edit',
  'agent.publish',
  'run.read',
  'run.create',
  'run.cancel',
  'tool.read',
  'tool.grant',
  'knowledge.read',
  'knowledge.manage',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const TENANT_ADMIN: readonly Permission[] = PERMISSIONS.filter((p) => p !== 'tenant.manage');

const TENANT_MEMBER: readonly Permission[] = [
  'member.read',
  'agent.read',
  'run.read',
  'run.create',
  'tool.read',
  'knowledge.read',
];

export const ROLE_PERMISSIONS: Record<TenantRole, readonly Permission[]> = {
  tenant_admin: TENANT_ADMIN,
  tenant_member: TENANT_MEMBER,
};

// Platform admins act inside any tenant with full tenant-admin rights plus tenant management.
export const PLATFORM_ADMIN_PERMISSIONS: readonly Permission[] = PERMISSIONS;

export function permissionsFor(role: TenantRole | null, isPlatformAdmin: boolean): ReadonlySet<Permission> {
  if (isPlatformAdmin) return new Set(PLATFORM_ADMIN_PERMISSIONS);
  return new Set(role ? ROLE_PERMISSIONS[role] : []);
}
